import React, { useMemo } from 'react';
import { ValueContainerProps } from 'react-select';
import { MReactSelectOption } from '../MSelect.model';

import MSelectValueContainerView from './MSelectValueContainer.view';
import { useTranslation } from 'react-i18next';

const MSelectValueContainer = <IsMulti extends boolean>(
  props: ValueContainerProps<MReactSelectOption, IsMulti> & { displayItemsCount: boolean },
): JSX.Element => {
  const { t } = useTranslation();

  const [placeholder, input] = props.children as [JSX.Element, JSX.Element];

  const value = useMemo(() => {
    const selected = props.getValue() || [];

    if (selected.length >= 1) {
      if (!props.displayItemsCount) {
        return selected.length <= 2
          ? selected.length === 1
            ? `${selected[0].label}, `
            : `${selected.map((s) => s.label).join(', ')}, `
          : t('common.items', { count: selected.length });
      }

      return selected.length === 1 ? selected[0].label : t('common.selected', { count: selected.length });
    }

    return placeholder;
  }, [props.getValue(), placeholder]);

  return (
    <MSelectValueContainerView {...props}>
      {value}
      {input}
    </MSelectValueContainerView>
  );
};

MSelectValueContainer.displayName = 'MSelectValueContainer';
MSelectValueContainer.defaultProps = {};

export default MSelectValueContainer;
